var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 learn_play_slider d-inline-block"},[_c('div',{staticClass:"learn_play_animate animateToLeft"},_vm._l((_vm.gamesData),function(game,index){return _c('div',{key:index,staticClass:"single_block",class:[{ cardVerticalGap: index % 2 }]},[_c('GameVerticalPhotoCard',{attrs:{"game":game}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }